import { render, staticRenderFns } from "./Pronunciation.vue?vue&type=template&id=0ecaf370&lang=pug&"
import script from "./Pronunciation.vue?vue&type=script&lang=js&"
export * from "./Pronunciation.vue?vue&type=script&lang=js&"
import style0 from "./Pronunciation.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports